import styled, { css } from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledDropdownItemText = styled.span`
    ${mixins.setFont({
        $color: colorsPalettes.carbon["500"],
        $size: 14,
        $weight: 400,
    })};
    line-height: 44px;
`;

export const StyledDropdownItem = styled.div<{ isDisabled: boolean; isSelected: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${({ isSelected }) => (isSelected ? colorsPalettes.bluegrey["100"] : colorsPalettes.carbon["0"])};
    box-sizing: border-box;
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
    height: 44px;
    padding: 0 16px;

    ${({ isDisabled }) =>
        isDisabled
            ? css`
                  & ${StyledDropdownItemText} {
                      color: ${colorsPalettes.carbon["100"]};
                  }
              `
            : css`
                  &:hover {
                      background-color: ${colorsPalettes.carbon["25"]};
                  }
              `};
`;
